import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'brand-national-geographic', 'BrandNationalGeographic', [["path",{"d":"M7 3h10v18h-10l0 -18","key":"svg-0"}]]);